import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PppDriverEligibilityComponent } from './pages/ppp-driver-eligibility/ppp-driver-eligibility.component';
import { PppLoadBonusesComponent } from './pages/ppp-load-bonuses/ppp-load-bonuses.component';
import { PppOverviewComponent } from './pages/ppp-overview/ppp-overview.component';
import { PppProgramRulesComponent } from './pages/ppp-program-rules/ppp-program-rules.component';
import { PppShellComponent } from './ppp-shell/ppp-shell.component';

const routes: Routes = [
  {
    path: '',
    component: PppShellComponent,
    children: [
      { path: '', component: PppOverviewComponent, pathMatch: 'full' },
      { path: 'drivers', component: PppDriverEligibilityComponent },
      { path: 'bonuses', component: PppLoadBonusesComponent },
      { path: 'rules', component: PppProgramRulesComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PreferredPartnerRoutingModule {}
